import {FC, forwardRef} from 'react'
import {formatToShortDateString} from 'app/format/date'
import Address from './Address'
import FulfilledItemList from './FulfilledItemList'
import Footer from './Footer'
import GiftMessage from 'app/features/orders/components/customer/GiftMessage'
import {mapToAddress} from 'app/features/orders/redux/order/helper'

type Props = {
  fulfillment: any
  order: any
  ref?: any
  store: any
}

const PackageSlip: FC<Props> = forwardRef(({fulfillment, order, store}, ref: any) => {
  const {orderAddressProfiles} = order
  const shippingAddress = mapToAddress(
    orderAddressProfiles?.nodes,
    order.shippingAddress,
    'shipping'
  )
  const billingAddress = mapToAddress(orderAddressProfiles?.nodes, order.billingAddress, 'billing')
  return (
    <div className='card' ref={ref}>
      <div className='card-body p-lg-20'>
        <div className='d-flex flex-column'>
          {/* Store Header */}
          <div className='flex-lg-row-fluid me-xl-18 mb-10 mb-xl-0'>
            <div className='mt-n1'>
              <div className='d-flex flex-stack'>
                <span className='fw-boldest text-gray-800 fs-2qx pe-5 pb-7'>{store.name}</span>
              </div>
            </div>
          </div>

          {/* Order */}
          <div className='m-0'>
            <div className='fw-bolder fs-3 text-gray-800 mb-8'>
              <div className='fw-bolder fs-3 text-gray-800 mb-1'>
                Order {`# ${order.orderNumber}`}
              </div>
              <div className='fw-bolder fs-6 text-gray-800'>
                {formatToShortDateString(order.createdAt)}
              </div>
            </div>

            {/* Address */}
            <div className='table-responsive mb-12'>
              <table className='table'>
                <tbody>
                  <tr>
                    <td>
                      <Address address={shippingAddress} title='Shipping Address' />
                    </td>
                    <td>
                      <Address address={billingAddress} title='Billing Address' />
                    </td>
                    <td>
                      <GiftMessage message={order.giftMessage} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Items */}
            <FulfilledItemList
              items={
                fulfillment.fulfillmentItems.nodes
                  ? fulfillment.fulfillmentItems.nodes
                  : fulfillment.fulfillmentItems
              }
            />
            <Footer store={store} />
          </div>
        </div>
      </div>
    </div>
  )
})

export default PackageSlip
